import { render, staticRenderFns } from "./afSolutionDetails.vue?vue&type=template&id=6c1bdfb8&scoped=true&"
import script from "./afSolutionDetails.vue?vue&type=script&lang=js&"
export * from "./afSolutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./afSolutionDetails.vue?vue&type=style&index=0&id=6c1bdfb8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1bdfb8",
  null
  
)

export default component.exports